/**
 * Runs vocabulary writes one after another. The API rewrites the whole
 * vocabulary on every save, so two saves in flight at once could land in
 * either order and the later edit could be overwritten by the earlier one.
 * Queued, the last edit the owner made is always the last one stored.
 */
let tail: Promise<unknown> = Promise.resolve();

export const enqueueVocabularyWrite = <T>(write: () => Promise<T>): Promise<T> => {
  const next = tail.then(write);
  tail = next.catch(() => undefined);
  return next;
};
